import { MutationHookOptions, useMutation } from "@apollo/client";
import addProductToCartGql from "@whoppah/apollo/mutation/addProductToCart.graphql";
import {
  AddProductToCartMutation,
  AddProductToCartMutationVariables,
} from "@whoppah/apollo/schema";

const useAddProductToCart = (
  options?: MutationHookOptions<
    AddProductToCartMutation,
    AddProductToCartMutationVariables
  >
) => {
  return useMutation(addProductToCartGql, options);
};

export default useAddProductToCart;
